/* @jsx h */
import { defineComponent, h, ref, watch } from "vue";
import { RouterLink, useRoute } from "vue-router";
import { Device } from "@lemmonhq/types";
import { cn } from "@lemmonhq/uikit";
import { isPrinterOnline } from "@app/utils/index";
import { useShop } from "../../providers";
import { PrinterSetupWizard } from "./PrinterSetupWizard";

export const DeviceMenu = defineComponent({
  name: "DeviceMenu",
  props: {
    devices: { type: Array as () => Device[], required: true },
  },
  setup(props) {
    const route = useRoute();
    const printers = props.devices.filter((d) => d.type === "printer");
    const terminals = props.devices.filter(
      (d) => d.type === "payment_terminal",
    );
    const showSetupWizard = ref(false);

    const getLinkClass = (isActive: boolean) => {
      return cn(
        "flex items-center gap-3 p-4 bg-[var(--component-bg-color)] border-l-4",
        isActive ? "border-blue-500" : "border-transparent",
      );
    };
    const shop = useShop();

    watch([shop.printerStatuses], async ([printerStatuses]) => {
      //console.log("watch triggered", printerStatuses);
    });

    const handleSetupSuccess = () => {
      // In production, this would refresh the devices list
      console.log("Printer setup completed successfully");
    };

    return () => (
      <div class="w-full md:w-64 border-r  pt-0">
        <div class="space-y-8">
          <div key="printers">
            <h2 class="text-2xl text-accent  border-b  px-2 py-4 mb-0 component">
              <span class="flex justify-between items-center w-full">
                <span class="flex justify-start items-center">
                  <span class="material-symbols-outlined mr-1 text-2xl border rounded  mr-3 w-8 h-8 flex items-center justify-center">
                    print
                  </span>
                  <span>Devices</span>
                </span>
                <button
                  onClick={() => (showSetupWizard.value = true)}
                  class="btn btn-primary btn-sm"
                  title="Setup Printer"
                >
                  <span class="material-symbols-outlined text-base">add</span>
                  <span class="hidden lg:inline">Setup</span>
                </button>
              </span>
            </h2>
            {printers.length > 0 && (
              <div class="space-y-2">
                {printers.map((printer) => (
                  <RouterLink
                    key={printer.device.id}
                    to={`/app/devices/printer/${printer.device.id}`}
                    class={getLinkClass(
                      route.params.id === printer.device.id.toString(),
                    )}
                  >
                    {() => (
                      <div class="flex-1 flex flex-col">
                        <div class="text-accent truncate text-ellipsis">
                          {printer.device.name}
                          <span
                            class={
                              "w-2 h-2 inline-block rounded-lg ml-2 " +
                              (isPrinterOnline(
                                shop.printerStatuses.timestamps,
                                printer.device.id,
                              )
                                ? "bg-success"
                                : "bg-warning")
                            }
                          ></span>
                        </div>
                        <div>EPSON TM-M30III</div>
                        <div class="font-mono">
                          S/N: {printer.device.serial_number}
                        </div>
                        <div class="font-mono">IP: {printer.device.ip}</div>
                      </div>
                    )}
                  </RouterLink>
                ))}
              </div>
            )}
          </div>

          {terminals.length > 0 && (
            <div key="terminals">
              <h2 class="text-1xl text-accent uppercase border-b  px-2 pb-1 mb-2">
                <span class="flex justify-start items-center">
                  <span class="material-symbols-outlined mr-1 text-2xl">
                    credit_card
                  </span>
                  Payment Terminals
                </span>
              </h2>
              <div class="space-y-2">
                {terminals.map((terminal) => (
                  <RouterLink
                    key={terminal.device.id}
                    to={`/app/devices/payment_terminal/${terminal.device.id}`}
                    class={getLinkClass(
                      route.params.id === terminal.device.id.toString(),
                    )}
                  >
                    {() => (
                      <div class="flex-1 flex flex-col">
                        <div class="text-accent">
                          {terminal.device.name}
                          <span class="bg-green-700 w-2 h-2 inline-block rounded-lg ml-2"></span>
                        </div>
                        <div>NextGO N86</div>
                      </div>
                    )}
                  </RouterLink>
                ))}
              </div>
            </div>
          )}

          <div class=" gap-4  mt-2 px-2 pt-2 hidden md:flex">
            <a
              onClick={(e) => {
                try {
                  (window as any).Beacon("open");
                  e.preventDefault();
                } catch (err) {
                } finally {
                }
              }}
              href="#"
              class="hover:text-accent flex items-center gap-1"
            >
              <span class="flex justify-start items-center">
                <span class="material-symbols-outlined mr-1 text-2xl">
                  open_in_new
                </span>
                Support
              </span>
            </a>
          </div>
        </div>

        {showSetupWizard.value && (
          <PrinterSetupWizard
            onClose={() => (showSetupWizard.value = false)}
            onSuccess={handleSetupSuccess}
          />
        )}
      </div>
    );
  },
});
